var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlarm(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.99998 11.8333C6.27081 11.8333 5.58792 11.6949 4.95131 11.418C4.31431 11.1407 3.76014 10.7662 3.28881 10.2945C2.81709 9.82318 2.44259 9.26902 2.16531 8.63202C1.88842 7.9954 1.74998 7.31252 1.74998 6.58335C1.74998 5.85418 1.88842 5.1711 2.16531 4.5341C2.44259 3.89749 2.81709 3.34332 3.28881 2.8716C3.76014 2.40027 4.31431 2.02615 4.95131 1.74927C5.58792 1.47199 6.27081 1.33335 6.99998 1.33335C7.72914 1.33335 8.41222 1.47199 9.04922 1.74927C9.68584 2.02615 10.24 2.40027 10.7117 2.8716C11.1831 3.34332 11.5574 3.89749 11.8346 4.5341C12.1115 5.1711 12.25 5.85418 12.25 6.58335C12.25 7.31252 12.1115 7.9954 11.8346 8.63202C11.5574 9.26902 11.1831 9.82318 10.7117 10.2945C10.24 10.7662 9.68584 11.1407 9.04922 11.418C8.41222 11.6949 7.72914 11.8333 6.99998 11.8333ZM8.63331 9.03335L9.44998 8.21668L7.58331 6.35002V3.66668H6.41664V6.81668L8.63331 9.03335ZM3.26664 0.37085L4.08331 1.18752L1.60414 3.66668L0.787476 2.85002L3.26664 0.37085ZM10.7333 0.37085L13.2125 2.85002L12.3958 3.66668L9.91664 1.18752L10.7333 0.37085Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlarm);
export default __webpack_public_path__ + "static/media/alarm.7a7c15649c58a4443487db37c8aada56.svg";
export { ForwardRef as ReactComponent };